import { createServiceToken } from '@/app/di';
import type { SettingsService } from './infrastructure/settings.service';
import type { ProcedureCatalogService } from './infrastructure/procedure-catalog.service';

export const SETTINGS_SERVICE = createServiceToken<SettingsService>('SettingsService');

export const PROCEDURE_CATALOG_SERVICE =
  createServiceToken<ProcedureCatalogService>('ProcedureCatalogService');
